import React, { useEffect, useState, memo } from "react";
import PropTypes from "prop-types";
import FullScreenLoader from "UIComponents/FullScreenLoader";
import { GEOGEBRA_URL } from "../GraphConstants";
import loadScript from "load-script";
const Geogebra = memo(props => {
  const { appletOnLoad, id } = props;
  const [deployggbLoaded, setDeployggbLoaded] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!deployggbLoaded && !window.GGBApplet) {
      loadScript(GEOGEBRA_URL, (err, script) => {
        setLoading(true);
        if (err) {
          setLoading(false);
        } else {
          script.id = `${id}-script`;
          setDeployggbLoaded(true);
          setLoading(false);
        }
      });
    }

    return () => {
      setDeployggbLoaded(false);
    };
  }, []);

  useEffect(() => {
    if (window.GGBApplet) {
      const parameter = JSON.parse(JSON.stringify(props));
      parameter.appletOnLoad = appletOnLoad;
      const ggbApp = new window.GGBApplet(parameter, true);
      ggbApp.inject(id);
      setLoading(false);
    }
  }, [deployggbLoaded, props]);

  return (
    <div id={`${id}-holder`} style={{ height: "100%", width: "100%" }}>
      {loading ? <FullScreenLoader /> : null}
      <div style={{ height: "100%", width: "100%" }} id={id}></div>
    </div>
  );
});

Geogebra.displayName = "Geogebra";
Geogebra.propTypes = {
  id: PropTypes.string,
  debug: PropTypes.bool,
  borderColor: PropTypes.string,
  showAlgebraInput: PropTypes.string,
  enableLabelDrags: PropTypes.string,
  enableShiftDragZoom: PropTypes.string,
  capturingThreshold: PropTypes.string,
  showToolBarHelp: PropTypes.string,
  errorDialogsActive: PropTypes.string,
  allowStyleBar: PropTypes.string,
  showMenuBar: PropTypes.string,
  appletOnLoad: PropTypes.func,
  showKeyboardOnFocus: PropTypes.string,
  customToolBar: PropTypes.string,
  ggbBase64: PropTypes.string,
};
Geogebra.defaultProps = {
  id: "ggb-applet",
  debug: false,
};

export default Geogebra;
